// src/components/Login.jsx
import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { storeToken } from '../utils/auth';
import { API_BASE } from '../services/api';
import styles from './Login.module.css';

const Login = () => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${API_BASE}/api/token/`, credentials);
      storeToken(res.data.access);
      navigate('/map');
    } catch (error) {
      setError('Invalid username or password');
    }
  };

  return (
    <div className={styles.loginContainer}>
      <form className={styles.loginForm} onSubmit={handleSubmit}>
        <h2 className={styles.title}>Palli Routes</h2>
        {error && <div className={styles.error}>{error}</div>}

        <input
          type="text"
          placeholder="Username"
          className={styles.input}
          value={credentials.username}
          onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
        />

        <input
          type="password"
          placeholder="Password"
          className={styles.input}
          value={credentials.password}
          onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
        />

        <button type="submit" className={styles.button}>Login</button>
      </form>
    </div>
  );
};

export default Login;
